import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getjobReviewApi, gettingJobListApi, jobDetailsApi, jobReviewRatingCreateApi } from "../../services/api/jobsApis";

const initialState = {
  jobList: [],
  isFetching: false,
  error: null,
  isError: false,
  jobDetails: null,
  dataCount: 0,
  dataPerPage: 5,
  currentpage: 1,
  dataRange: null,
  selectedjobReview: null,
};

export const getJobListings = createAsyncThunk(
  "get/job/lists",
  async (values, { rejectWithValue }) => {
    try {
      const data = await gettingJobListApi(values);

      if (data?.serverResponse?.code !== 200) return rejectWithValue(data);
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const jobDetailsById = createAsyncThunk(
  "job/details/byId",
  async (values, { rejectWithValue }) => {
    try {
      const data = await jobDetailsApi(values);
      if (data?.serverResponse?.code !== 200) return rejectWithValue(data);
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const jobReviewRatingCreate = createAsyncThunk(
  "add-job-review",
  async (values, { rejectWithValue }) => {
    try {
      const data = await jobReviewRatingCreateApi(values.values);
      if (data?.serverResponse?.code !== 200) return rejectWithValue(data);
      values.navigate('/review/thank-you')
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getjobReview = createAsyncThunk(
  "get-job-review",
  async (values, { rejectWithValue }) => {
    try {
      const data = await getjobReviewApi(values);
      if (data?.serverResponse?.code !== 200) return rejectWithValue(data);
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const jobsSlice = createSlice({
  name: "jobs",
  initialState,
  reducers: {
    clearJobs: (state) => {
      state.jobList = [];
      state.isFetching = false;
      state.isError = false;
      state.error = null;
      state.jobDetails = null;
      state.dataCount = 0;
      state.dataPerPage = 5;
      state.currentpage = 1;
      state.dataRange = null;
    },
  },
  extraReducers: {
    [getJobListings.pending]: (state) => {
      state.isFetching = true;
      state.isError = false;
      return state;
    },
    [getJobListings.fulfilled]: (state, { payload }) => {
      state.jobList = [...state.jobList, ...payload.result?.data];
      state.isFetching = false;
      state.isError = false;
      state.error = null;
      state.dataCount = payload.result?.pagination?.totalResults;
      state.dataPerPage = payload.result?.pagination?.limit;
      state.currentpage = payload.result?.pagination?.page;
      state.dataRange = payload.result?.pagination?.dataRange;
      return state;
    },
    [getJobListings.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.error = payload;
      return state;
    },
    [jobDetailsById.pending]: (state) => {
      state.isFetching = true;
      state.isError = false;
      return state;
    },
    [jobDetailsById.fulfilled]: (state, { payload }) => {
      state.jobDetails = payload?.result;
      state.isFetching = false;
      state.isError = false;
      state.error = null;
      return state;
    },
    [jobDetailsById.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.error = payload;
      return state;
    },
    [getjobReview.pending]: (state) => {
      state.isFetching = true;
      state.isError = false;
      return state;
    },
    [getjobReview.fulfilled]: (state, { payload }) => {
      state.selectedjobReview = payload?.result;
      state.isFetching = false;
      state.isError = false;
      state.error = null;
      return state;
    },
    [getjobReview.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.error = payload;
      return state;
    },
  },
});

// this is for dispatch
export const { clearJobs } = jobsSlice.actions;

// this is for configureStore
export default jobsSlice.reducer;
